<dx-popup
  [(visible)]="visible"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  width="60%"
  height="70%"
  [fullScreen]="fullScreen"
  [showTitle]="true"
  [title]="getTitle()"
  [showCloseButton]="true"
  (onHiding)="onCancel()">

  <dxi-popup-toolbar-item
    toolbar="bottom"
    location="after"
    widget="dxButton"
    [options]="{
      stylingMode: 'outlined', 
      text: ('Abbrechen' | translate),
      type: 'normal',
      icon: 'close',
      onClick: onCancel,
      disabled: isSaving
    }">
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    toolbar="bottom"
    location="after"
    widget="dxButton"
    [options]="{
      stylingMode: 'outlined', 
      text: ('Importieren' | translate),
      type: 'default',
      icon: 'save',
      onClick: onImportClick,
      disabled: isSaving
    }">
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <div class="p-4 import-dialog">
      <dx-tab-panel
        [dataSource]="pages"
        [(selectedIndex)]="selectedTabIndex"
        [animationEnabled]="true"
        [swipeEnabled]="false">

        <div *dxTemplate="let p of 'upload'">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Datei' | translate }}
              </div>
              <div class="dx-field-value">
                <dx-file-uploader
                  class="catalog-uploader"
                  [ngClass]="{ 'has-file': hasFileSelected }"
                  #dxUploader
                  name="file"
                  [uploadUrl]="uploadUrl"
                  [uploadHeaders]="uploadHeaders"
                  [multiple]="false"
                  [chunkSize]="chunkSize"
                  [accept]="fileTypes"
                  uploadMode="useButtons"
                  (onBeforeSend)="onBeforeSendUpload($event)"
                  (onProgress)="onUploadProgress()"
                  (onUploaded)="onUploaded()"
                  (onValueChanged)="onFileSelectionChanged($event)"
                  [selectButtonText]="hasFileSelected ? '' : ('Datei auswählen' | translate)"
                  [labelText]="hasFileSelected ? '' : ('oder Drag und Drop' | translate)"
                  invalidFileExtensionMessage="{{ 'Bitte nur xml zip xlsx xls oder csv Dateien auswählen' | translate }}."
                  invalidMaxFileSizeMessage="{{ 'Die Datei ist leider zu groß' | translate }}"
                  invalidMinFileSizeMessage="{{ 'Die Datei ist leider zu klein' | translate }}"
                  uploadFailedMessage="{{ 'Hochladen fehlgeschlagen' | translate }}">
                </dx-file-uploader>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Verwendung' | translate }}
              </div>
              <div class="dx-field-value">
                <dx-radio-group
                  [value]="importMode"
                  (onValueChanged)="onImportModeChanged($event)"
                  [items]="importModeItems"
                  displayExpr="text"
                  valueExpr="value"
                  layout="vertical">
                </dx-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div *dxTemplate="let p of 'ftp'">
          <div class="dx-fieldset">

            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Verbindungsname' | translate }}
              </div>
              <div class="dx-field-value">
                <dx-select-box
                  [items]="connectionItems"
                  displayExpr="name"
                  valueExpr="id"
                  [(value)]="selectedConnectionId"
                  (onValueChanged)="onConnectionChanged($event)">
                </dx-select-box>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Import Ordner' | translate }}
              </div>
              <div class="dx-field-value import-folder-row">
                <dx-select-box
                  class="import-folder-select"
                  [items]="importFolderItems"
                  [(value)]="selectedImportFolderId"
                  (onValueChanged)="onImportFolderChanged($event)">
                  <div *dxTemplate="let data of 'dropDownButton'">
                    <dx-load-indicator [visible]="isLoadingFolders"></dx-load-indicator>
                    <i class="dx-icon-spindown"></i>
                  </div>
                </dx-select-box>

                <dx-button
                  text="{{ 'Verbinden' | translate }}"
                  type="default"
                  (onClick)="onConnectClick()">
                </dx-button>
              </div>
            </div>

            <div class="dx-field" *ngIf="isConnected">
              <div class="dx-field-value ftp-connected">
                {{ 'Erfolgreich verbunden' | translate }}
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label"></div>
              <div class="dx-field-value">
                <div class="automatic-row">
                  <dx-check-box
                    [value]="isAutomatic"
                    (onValueChanged)="onAutomaticChanged($event)"
                    [text]="'Automatisch' | translate">
                  </dx-check-box>

                  <ng-container *ngIf="isAutomatic">
                    <dx-select-box
                      class="interval-select"
                      [items]="intervalItems"
                      [(value)]="selectedInterval"
                      (onValueChanged)="onIntervalChanged($event)">
                    </dx-select-box>
                  </ng-container>
                </div>

                <div class="ftp-time-row" *ngIf="isAutomatic">
                  <span class="ftp-time-label">
                    {{ 'Stunde' | translate }}
                  </span>
                  <dx-number-box
                    class="time-number"
                    [min]="0"
                    [max]="23"
                    [showSpinButtons]="true"
                    [(value)]="hour"
                    (onValueChanged)="onHourChanged($event)">
                  </dx-number-box>

                  <span class="ftp-time-label">
                    {{ 'Minute' | translate }}
                  </span>
                  <dx-number-box
                    class="time-number"
                    [min]="0"
                    [max]="59"
                    [showSpinButtons]="true"
                    [(value)]="minute"
                    (onValueChanged)="onMinuteChanged($event)">
                  </dx-number-box>
                </div>
              </div>
            </div>

            <div class="dx-field" *ngIf="isAutomatic && nextImport">
              <div class="dx-field-label">
                {{ 'Nächster Import' | translate }}
              </div>
              <div class="dx-field-value">
                {{ nextImport | date:"dd.MM.yyyy 'um' HH:mm 'Uhr'" }}
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">
                {{ 'Verwendung' | translate }}
              </div>
              <div class="dx-field-value">
                <dx-radio-group
                  [value]="importMode"
                  (onValueChanged)="onImportModeChanged($event)"
                  [items]="importModeItems"
                  displayExpr="text"
                  valueExpr="value"
                  layout="vertical">
                </dx-radio-group>
              </div>
            </div>

          </div>
        </div>

      </dx-tab-panel>
    </div>
  </div>
</dx-popup>
